import React from 'react';
import PropTypes from 'prop-types';


const Modal = ({
  children,
  onClose,
  open,
  isFullScreen,
  fitContent,
}) => (
  <div
    className={
    `Modal${open ? ' Modal-open' : ''}${isFullScreen ? ' Modal-fullScreen' : ''}${fitContent ? ' Modal-fitContent' : ''}`
    }>
    <div className="Modal_veil" onClick={onClose}></div>
    <div className="Modal_panel">
      {children}
    </div>
  </div>
);

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  isFullScreen: PropTypes.bool,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  fitContent: PropTypes.bool,
};

export default Modal;
